import React from 'react'
import { TripSearchSection } from './components/trip-search-section'
import BannerCompraImgMobile from '../../../assets/images/banners-cartao/banner-compra-mobile.png'
import PreLaunchContainer from './styles/pre-launch-container.style'
import MoveflexPartnersSection from './components/moveflex-partners-section.component'
import styled from 'styled-components'
import { connect } from 'react-redux'
import { isMobile } from '../../services/breakpoints.service'
import BannerService from '../../services/banner.service'
import { withRouter } from 'react-router-dom'
import { SubscribeForNews } from '../../components/layout/subscribe-for-news.component'
import CookieLGPD from '../../components/layout/cookieLGPD.component'
import ItemsCarousel from 'react-items-carousel'
import { Creators as SiteCreators } from '../../ducks/site/site'
import { bindActionCreators } from 'redux'
import MuvibusAdvantagesSection from '../../modules/muvibus/components/advantages/advantages.page'
import * as config from 'config'
import MoveflexStoreSection from './components/moveflex-store-section.component'
import { content } from '../../../config'
import {
	AppStoreBanner,
	ContainerAppStoreBtn
} from './styles/styled-app-store-banner'
import FixedFloatButtons from './components/fixed-float-button/fixed-float-button'
import { SeatModalitiesSection } from './components/seat-modalities-section'
import { ModuleRootComponent as FaqPage } from '../faq/faq.page'

const { APP_ANDROID_LINK, APP_IOS_LINK } = content

const IMAGE_BTN_APP_ANDROID = require(`../../../assets/images/logo-apps-stores/android/play-store-logo-black.svg`)
const IMAGE_BTN_APP_IOS = require('../../../assets/images/logo-apps-stores/ios/apps-store-logo-black.svg')

const StyledWrapper = styled.div`
	overflow: hidden;

	& > * {
		& ::-webkit-scrollbar {
			width: 0;
		}
	}
`

const noOfCards = 1
const autoPlayDelay = 20000
const chevronWidth = 20

class Launch extends React.Component {
	constructor(props) {
		super(props)
		this.storyContainer = null
		this.state = {
			busIsVisible: false,
			showVideoModal: false,
			images: [],
			hasMore: true,
			currentPage: 1,
			loadedPages: 0,
			activeItemIndex: 0,
			numberOfItems: 0,
			isMobile: isMobile()
		}
	}

	showBus = isVisible => this.setState({ busIsVisible: isVisible })

	gotoAbout = () => {
		this[`${isMobile() ? 'video' : 'story'}Container`].scrollIntoView({
			block: 'start',
			behavior: 'smooth'
		})
	}

	componentDidMount() {
		const { hideLoading } = this.props

		if (autoPlayDelay !== 0) {
			this.interval = setInterval(this.tick, autoPlayDelay)
		}

		var images = []

		BannerService.getBannerImages().then(({ data }) => {
			images = data
			this.setState({ images, numberOfItems: images.length })
		})

		hideLoading()
	}

	componentWillUnmount() {
		clearInterval(this.interval)
	}

	tick = () => {
		const { numberOfItems } = this.state
		this.setState(prevState => ({
			activeItemIndex:
				(prevState.activeItemIndex + 1) % (numberOfItems - noOfCards + 1)
		}))
	}

	onChange = value => this.setState({ activeItemIndex: value })

	importAll = r => {
		return r.keys().map(r)
	}

	render() {
		const { images, isMobile } = this.state

		return (
			<div>
				<PreLaunchContainer isMobile={isMobile}>
					<div className="container-banners">
						<StyledWrapper chevronWidth={chevronWidth}>
							{images && images.length > 0 && (
								<ItemsCarousel
									requestToChangeActive={this.onChange}
									activeItemIndex={this.state.activeItemIndex}
									numberOfCards={noOfCards}
									infiniteLoop={true}
									gutter={10}
									activePosition={'center'}
									leftChevron={
										<span
											style={{ display: 'none' }}
											aria-hidden="true"
											className="fa fa-angle-left fa-3x"></span>
									}
									rightChevron={
										<span
											style={{ display: 'none' }}
											aria-hidden="true"
											className="fa fa-angle-right fa-3x"></span>
									}
									outsideChevron={false}
									slidesToScroll={1}
									chevronWidth={chevronWidth}
									firstAndLastGutter={false}>
									{images.map((img, i) =>
										// i === 0 ? (
										// 	<div
										// 		key={i}
										// 		style={{
										// 			height: 444,
										// 			background: `url(${img})`,
										// 			backgroundRepeat: 'no-repeat',
										// 			backgroundSize: 'contain',
										// 			backgroundPositionX: 'center'
										// 		}}
										// 	/>
										// ) : i === 1 ? (
										// 	<a
										// 		href="https://api.whatsapp.com/send?phone=555540207488&text=Ol%C3%A1%2C%20eu%20gostaria%20de%20comprar%20passagem!%20"
										// 		title="WhastApp"
										// 		target="_blank"
										// 		key={i}
										// 		style={{
										// 			height: 444,
										// 			background: `url(${img})`,
										// 			backgroundRepeat: 'no-repeat',
										// 			backgroundSize: 'contain',
										// 			backgroundPositionX: 'center',
										// 			display: 'block',
										// 			textIndent: '-9000em'
										// 		}}>
										// 		WhatsApp
										// 	</a>
										// ) : i === 2 ? (
										// 	<a
										// 		href="/muvicard"
										// 		title="Muvicard"
										// 		key={i}
										// 		style={{
										// 			height: 444,
										// 			background: `url(${img})`,
										// 			backgroundRepeat: 'no-repeat',
										// 			backgroundSize: 'contain',
										// 			backgroundPositionX: 'center',
										// 			display: 'block',
										// 			textIndent: '-9000em'
										// 		}}>
										// 		Muvicard
										// 	</a>
										// ) : (
										<div
											key={i}
											style={{
												height: 444,
												background: `url(${img})`,
												backgroundRepeat: 'no-repeat',
												backgroundSize: 'contain',
												backgroundPositionX: 'center'
											}}
										/>
										// )
									)}
								</ItemsCarousel>
							)}
						</StyledWrapper>
					</div>
					<div className="trip-search-section">
						<TripSearchSection />
					</div>
					<div className="container-apps-store">
						<AppStoreBanner />
						<ContainerAppStoreBtn>
							<a
								href={APP_ANDROID_LINK}
								title="play-store"
								target="_blank"
								alt="Baixe na play store">
								<img
									src={IMAGE_BTN_APP_ANDROID}
									alt="Baixe o app no android"
								/>
							</a>
							<a
								href={APP_IOS_LINK}
								title="app-store"
								target="_blank"
								alt="Baixe na app store">
								<img src={IMAGE_BTN_APP_IOS} alt="Baixe o app no ios" />
							</a>
						</ContainerAppStoreBtn>
					</div>
					{/* <div className="banner-mobile">
						<a
							href="https://api.whatsapp.com/send?phone=555540207488&text=Ol%C3%A1%2C%20eu%20gostaria%20de%20comprar%20passagem!%20"
							title="WhastApp"
							target="_blank">
							<img
								className="img-responsive"
								src={BannerCompraImgMobile}
								alt="Muvicard"
							/>
						</a>
					</div> */}
				</PreLaunchContainer>
				{/* <MoveflexPartnersSection /> */}
				<MoveflexStoreSection />
				<MuvibusAdvantagesSection />
				{content.BRAND_NAME === 'Planalto' && <SeatModalitiesSection />}
				<FaqPage />
				<SubscribeForNews />
				<CookieLGPD />
				<FixedFloatButtons />
			</div>
		)
	}
}

const mapStateToProps = ({ user }) => ({
	user
})

const mapDispatchToProps = dispatch =>
	bindActionCreators(
		{
			hideLoading: SiteCreators.hideLoading
		},
		dispatch
	)

const connectedLaunch = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(Launch)
)

export { connectedLaunch as ModuleRootComponent }
